import { isSameVin, vinSearchQuery, FULL_VIN_LENGTH } from '../../Car/NewCar/vinSearch';

// Ð¤Ð¾ÑÐ¼Ñ Ð½Ð¾Ð²Ð¾Ð³Ð¾ Ð°Ð²ÑÐ¾ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼, ÐºÐ¾Ð³Ð´Ð° VIN Ð²Ð²ÐµÐ´ÑÐ½ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼, Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ Ð½ÐµÐ¼Ñ Ð·Ð°ÐºÐ¾Ð½ÑÐ¸Ð»ÑÑ Ð¸ ÑÐ¾ÑÐ½Ð¾Ð³Ð¾ ÑÐ¾Ð²Ð¿Ð°Ð´ÐµÐ½Ð¸Ñ Ð² Ð±Ð°Ð·Ðµ Ð½ÐµÑ.
// ÐÐ¾ÐºÐ° Ð¿Ð¾Ð¸ÑÐº Ð¸Ð´ÑÑ (Ð¸Ð»Ð¸ VIN ÐµÑÑ ÐºÐ¾ÑÐ¾ÑÐºÐ¸Ð¹), ÑÐ¾ÑÐ¼Ñ Ð½ÐµÑ: Ð¸Ð½Ð°ÑÐµ Ð¾Ð½Ð° Ð¼Ð¸Ð³Ð°Ð»Ð° Ð±Ñ Ð½Ð° ÐºÐ°Ð¶Ð´Ð¾Ð¼ Ð½Ð°Ð¶Ð°ÑÐ¸Ð¸ ÐºÐ»Ð°Ð²Ð¸ÑÐ¸.
export const needsNewCar = (vin, search) =>
  String(vin || '').length === FULL_VIN_LENGTH &&
  Boolean(search?.done) &&
  search.query === vinSearchQuery(vin) &&
  !(search.cars || []).some((car) => isSameVin(car, vin));
